import store from '@/store'
import texts from '@/data/data_texts'

const lang = (slug) => {
	if (store.getters.lang && texts[store.getters.lang][slug]) return texts[store.getters.lang][slug]
	return slug
}

export { lang }